<div>
  <a
    href="https://code.travail.gouv.fr/widgets/indemnite-rupture-conventionnelle"
    >Indemnité de rupture conventionnel</a
  >
</div>
